import { Injectable } from '@angular/core';
import {BaseDatabaseService} from '../databaseServices/BaseDatabaseService';
import {Voucher} from '../../classes/Voucher';

@Injectable({
  providedIn: 'root'
})
export class VoucherService extends BaseDatabaseService{

  private collectionName = 'vouchers';

  vouchers: Voucher[] = [];
  editVoucherId = -1;

  constructor() {
    super();
  }

  create(vouchers: Voucher[], id) {
    vouchers = vouchers.map(item => Object.assign({}, item));
    const obj = Object.assign({}, {
      vouchers: vouchers
    });
    return this.db.collection(this.collectionName).doc(id).set(obj);
  }

  readOne(id){
    return this.db.collection(this.collectionName).doc(id).get();
  }

  readAll() {
    return this.db.collection(this.collectionName).get();
  }

  update(vouchers: Voucher[], id) {
    vouchers = vouchers.map(item => Object.assign({}, item));
    const obj = Object.assign({}, {
      vouchers: vouchers
    });
    const ref = this.db.collection(this.collectionName).doc(id);
    return ref.update(obj);

  }

  delete(id) {

  }


}
